import styled from "styled-components";
import { Flex } from "antd";
import spacing from "theme/spacing.module.scss";

export const StyledFlex = styled(Flex)`
    min-height: 80vh;
    padding: ${spacing.spacingLG};
    overflow-y: auto;
`;
